import { useEffect, useState } from 'react';

import { isAndroid, isiOS } from '../utils/helpers';

const isWindows = /Windows/.test(navigator.userAgent);
const isMac = /Macintosh/.test(navigator.userAgent);
const isLinux = /Linux/.test(navigator.userAgent);

type TDevice = 'android' | 'ios' | 'windows' | 'mac' | 'linux' | 'unknown_platform';

type TBrowser =
  | 'FIREFOX'
  | 'CHROME'
  | 'SAFARI'
  | 'EDGE'
  | 'OPERA'
  | 'INTERNET_EXPLORER'
  | 'UNKNOWN_BROWSER';

const useDetailDevice = () => {
  let osDevice: TDevice;
  let osVersion = undefined;
  let browser: TBrowser;

  const [userAgent, setUserAgent] = useState(navigator.userAgent);

  const handleResize = () => {
    setUserAgent(navigator.userAgent);
  };
  useEffect(() => {
    window.addEventListener('resize', handleResize, false);
  }, []);

  if (isAndroid) {
    const androidVersionMatch = userAgent.match(/Android\s([\d.]+)/);
    osDevice = 'android';
    osVersion = androidVersionMatch && parseFloat(androidVersionMatch[1]);
  } else if (isiOS) {
    const iOSVersionMatch = userAgent.match(/OS\s([\d_]+)/);
    osDevice = 'ios';
    osVersion = iOSVersionMatch && parseFloat(iOSVersionMatch[1].replace(/_/g, '.'));
  } else if (isWindows) {
    const windowsVersionMatch = userAgent.match(/Windows\s([\d.]+)/);

    osDevice = 'windows';
    osVersion = windowsVersionMatch && windowsVersionMatch[1];
  } else if (isMac) {
    const macVersionMatch = userAgent.match(/Mac\sOS\sX\s([\d_]+)/);

    osDevice = 'mac';
    osVersion = macVersionMatch && parseFloat(macVersionMatch[1].replace(/_/g, '.'));
  } else if (isLinux) {
    osDevice = 'linux';
  } else {
    osDevice = 'unknown_platform';
  }

  if (/Firefox/i.test(userAgent)) {
    browser = 'FIREFOX';
  } else if (/Chrome/i.test(userAgent)) {
    browser = 'CHROME';
  } else if (/Safari/i.test(userAgent)) {
    browser = 'SAFARI';
  } else if (/Edge/i.test(userAgent)) {
    browser = 'EDGE';
  } else if (/Opera|OPR/i.test(userAgent)) {
    browser = 'OPERA';
  } else if (/Trident/i.test(userAgent)) {
    browser = 'INTERNET_EXPLORER';
  } else {
    browser = 'UNKNOWN_BROWSER';
  }

  return { osDevice, osVersion: osVersion ? osVersion : undefined, browser };
};

export default useDetailDevice;
